import angular from "angular"

var SERVICE_NAME = "permissionService"

angular.module("appModule").service(SERVICE_NAME, [
  "store",
  function(store) {
    var self = this

    self.descargarReportes = function() {
      var user = store.get("user")
      return user.app_permissions.includes("descargarReportes")
    }

    self.mantenedorUsuarios = function() {
      var user = store.get("user")
      return user.app_permissions.includes("mantenedorUsuarios")
    }

    self.mantenedorAtenciones = function() {
      var user = store.get("user")
      return user.app_permissions.includes("mantenedorAtenciones")
    }

    self.eliminarAtenciones = function() {
      var user = store.get("user")
      return user.app_permissions.includes("eliminarAtenciones")
    }

    self.eliminarAlertas = function() {
      var user = store.get("user")
      return user.app_permissions.includes("eliminarAlertas")
    }

    self.eliminarComentarios = function() {
      var user = store.get("user")
      return user.app_permissions.includes("eliminarComentarios")
    }

    self.editarSoloAtencionesMasivas = function() {
      var user = store.get("user") || {}
      return user.app_permissions.includes("editarSoloAtencionesMasivas")
    }

    self.escribirComentariosPrivados = function() {
      var user = store.get("user")
      return user.app_permissions.includes("escribirComentariosPrivados")
    }

    self.editEnrollmentState = function() {
      var user = store.get("user")
      return user.app_permissions.includes("app_edit_enrollment_state")
    }

    self.downloadUserPermissionsReport = function() {
      var user = store.get("user")
      return user.app_permissions.includes("app_download_user_permissions_report")
    }

    self.hasSpecificRole = function(roleName) {
      if (roleName) {
        var user = store.get("user")
        return user.hasOwnProperty("rol") && user.rol === roleName
      } else {
        return false
      }
    }

    return {
      descargarReportes: self.descargarReportes,
      mantenedorUsuarios: self.mantenedorUsuarios,
      mantenedorAtenciones: self.mantenedorAtenciones,
      eliminarAtenciones: self.eliminarAtenciones,
      eliminarAlertas: self.eliminarAlertas,
      eliminarComentarios: self.eliminarComentarios,
      editarSoloAtencionesMasivas: self.editarSoloAtencionesMasivas,
      hasSpecificRole: self.hasSpecificRole,
      escribirComentariosPrivados: self.escribirComentariosPrivados,
      editEnrollmentState: self.editEnrollmentState,
      downloadUserPermissionsReport: self.downloadUserPermissionsReport
    }
  }
])

export default SERVICE_NAME
